import React, { Fragment, useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import ShowClinicEvent from '../../ClinicEvent/components/ShowClinicEvent';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const PrintModal = ({ data, openPrintModal, setOpenPrintModal }) => {
    
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        //console.log(data)
        getPrintEvent();
    }, []);

    const getPrintEvent = () => {

        const dataSend = { id_historia: parseInt(data.id_historia), id_admision: parseInt(data.id_admision) }
        fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data);
                setLoading(false);                
            })
            .catch((error) => {
                alert(error);
                console.error('Error:', error);
            });
    }

    return (
        <Fragment>
            {!loading ?
                <Modal
                    open={openPrintModal}
                    onClose={() => {
                        setOpenPrintModal(false);
                      }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                    disableEnforceFocus={true}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%' }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setOpenPrintModal(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <ShowClinicEvent data={data} />
                    </div>
                </Modal> :
                <Modal
                    open={loading}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div style={{
                        position: 'absolute',
                        backgroundColor: '#ffffff',
                        width: 200,
                        height: 200,
                        backgroundColor: 'white',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        display: 'flex'
                    }}
                    >
                        <div className="load__icon-wrap">
                            <svg className="load__icon">
                                <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                            </svg>
                        </div>
                    </div>
                </Modal>}
        </Fragment>)
}

export default PrintModal;